import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { getTheme } from "Theme";

const theme = getTheme();

const MenuButton = styled.div`
  padding: 5px;
  display: flex;
  position: absolute;
  height: 30px;
  align-items: center;
  margin-top: -15px;
  min-width: 30px;
  right: 20px;
`;

const QuickMenuItem = styled.div`
  border-radius: 8px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  font-size: 12px;
  background-color: ${theme.TABLE_ROW};
  padding: 0 10px;
  align-items: center;
  display: flex;
  height: 30px;
  border: 1px solid ${theme.BUTTON_COLOR_GREY};
  cursor: pointer;
  :hover {
    color: ${theme.MAIN_COLOR};
  }
`;

const MenuButtonIcon = styled(FontAwesomeIcon)`
  width: 15px;
  border-radius: 8px;
  height: 28px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  padding: 0 10px;
  border: 1px solid
    ${(props) => (props.show ? theme.BUTTON_COLOR_GREY : "transparent")};

  ${(props) => props.show && `  background-color: ${theme.TABLE_ROW}; `}
  :hover {
    color: ${theme.MAIN_COLOR};
  }
`;

const Menu = styled.td`
  width: 200px;
`;

const MenuItemList = styled.div`
  position: absolute;
  background-color: white;
  border: 1px solid ${theme.BUTTON_COLOR_GREY};
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 200px;
`;

const MenuItemOption = styled.div`
  padding: 10px 12px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  font-size: 12px;
  color: ${(props) => (props.disabled ? theme.BUTTON_COLOR_GREY : "black")};
  :hover {
    background-color: ${(props) =>
      props.disabled ? theme.BUTTON_COLOR_NEGATIVE : theme.SUCCESS};
  }
`;

const RowMenu = ({
  data,
  index,
  menu,
  quickMenuOpen,
  onQuickMenuClick,
  menuOpen,
  quickMenuOption,
}) => {
  return (
    <Menu>
      <MenuButton show={quickMenuOpen === index ? true : undefined}>
        {quickMenuOpen === index && quickMenuOption && (
          <QuickMenuItem
            onClick={(e) => {
              quickMenuOption.action(data);
              onQuickMenuClick(null);
              e.stopPropagation();
            }}
          >
            {quickMenuOption.label}
          </QuickMenuItem>
        )}
        <MenuButtonIcon
          show={quickMenuOpen === index ? true : undefined}
          icon={faEllipsis}
          onClick={(e) => {
            onQuickMenuClick(menuOpen !== index ? index : null);
            e.stopPropagation();
          }}
        />
      </MenuButton>
      <MenuItemList
        style={{
          display: menuOpen === index ? "block" : "none",
          right: "10px",
          marginTop: "20px",
        }}
      >
        {menu &&
          menu.map((item, idx) => (
            <MenuItemOption
              key={idx}
              disabled={item.disabled(data)}
              onClick={(e) => {
                if (!item.disabled(data)) {
                  item.action(data);
                  onQuickMenuClick(null);
                }
                e.stopPropagation();
              }}
            >
              {item.label}
            </MenuItemOption>
          ))}
      </MenuItemList>
    </Menu>
  );
};

export default RowMenu;
